/**
 * Redesign v2: il collegamento "Che taglia scegliere?" sta nella riga della taglia
 * e apre la guida taglie esistente (blocco size-guide) senza duplicarne il contenuto.
 */
if (!window.__gdmSizeLinkReady) {
  window.__gdmSizeLinkReady = true;

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-gdm-size-link]') : null;
    if (!link) return;

    event.preventDefault();
    const scope = link.closest('.product-details') || document;
    const trigger = scope.querySelector('.size-guide-drawer__trigger');
    if (trigger instanceof HTMLElement) trigger.click();
  });
}
